/**
 * KAN-306 round 6 (CRITICAL, live dev): the API layer serializes Postgres
 * numeric/decimal columns as STRINGS in JSON responses (a documented,
 * recurring bug class in this codebase -- see the project's serializer
 * notes on pg types not guaranteeing JS number types). VideoProgressService
 * seeded its round-5 interval-tracking baseline directly from a GET
 * response field without numeric coercion; when that field arrived as a
 * string (e.g. "403"), every subsequent `persistedSeedSeconds + coverage`
 * computation became STRING CONCATENATION instead of addition
 * ('403' + 10.08 -> '40310.08'), exploding to the capped duration and
 * getting PERSISTED server-side as a false 100% complete within 1-2
 * heartbeats of any playback.
 *
 * Every numeric value read from a backend response that feeds arithmetic
 * MUST be parsed through this helper at the response boundary, once --
 * not scattered `Number(...)` calls of inconsistent shape at each call
 * site, which is exactly how this gap was missed (some fields already had
 * a bare `Number(...)`, others didn't).
 *
 * @requirements REQ-VIDEO-107
 */
export function parseBackendNumber(value: unknown, fallback = 0): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}
